import { render } from "./Dialog.vue?vue&type=template&id=5825b4d7"
import script from "./Dialog.vue?vue&type=script&lang=js"
export * from "./Dialog.vue?vue&type=script&lang=js"
script.render = render

export default script